import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactUsComponent } from './contact-us.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';

@NgModule({
  declarations: [ContactUsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    PipesModule,
    FGBSharedModule
  ],
  exports: [ContactUsComponent],
})
export class ContactUsModule {}
